import React from 'react';

import { ColorSchemeContext, ColorSchemeValueContext } from '@/context/colorSchemeContext';
import { useUserPreferences } from '@/hooks/useUserPreferences';

export const ColorSchemeProvider: React.FC<React.PropsWithChildren> = (
  props: React.PropsWithChildren,
): React.ReactElement => {
  const [preferences] = useUserPreferences();

  const { theme = 'light' } = preferences.appearance ?? {};
  const [colorScheme, setColorScheme] = React.useState<'light' | 'dark'>(theme);

  React.useEffect((): void => {
    const meta = document.querySelector<HTMLMetaElement>('meta[name="color-scheme"]');
    meta?.setAttribute('content', theme);

    setColorScheme(theme);
  }, [theme]);

  return (
    <ColorSchemeContext.Provider value={setColorScheme}>
      <ColorSchemeValueContext.Provider value={colorScheme}>
        {props.children}
      </ColorSchemeValueContext.Provider>
    </ColorSchemeContext.Provider>
  );
};
